<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Loyalty Dashboard</h1>
    </div>
    <div class="separator-breadcrumb border-top"></div>

    <!-- Takaful Brunei -->
    <div class="row">
      <div class="col-lg-4 col-md-4 col-12">
        <!-- <button @click="clickme(index)">clickme</button> -->
        <div class="card mb-4">
          <div class="card-body">
            <!-- Title -->
            <h3 style="color: #ac8400">Registered Vendors</h3>

            <br />

            <div class="row">
              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Active</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ regVendor.active }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%; color: #ac8400"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Inactive</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ regVendor.inactive }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <!-- Total -->
                <h5 class="mb-2 text-muted">Total</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ regVendor.active + regVendor.inactive }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-4 col-12">
        <div class="card mb-4">
          <div class="card-body">
            <!-- Title -->
            <h3 style="color: #ac8400">Redeemed Points</h3>

            <br />

            <div class="row">
              <div class="col">
                <h5 class="mb-2 text-muted">Vendors</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ formatNumber(redeem.vendors) }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <h5 class="mb-2 text-muted">Charity</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ formatNumber(redeem.charity) }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-4 col-12">
        <div class="card mb-4">
          <div class="card-body">
            <!-- Title -->
            <h3 style="color: #ac8400">TBM Points</h3>

            <br />

            <div class="row">
              <div class="col">
                <h5 class="mb-2 text-muted">Total Points Earned</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ formatNumber(tbm_points.total_earned) }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <h5 class="mb-2 text-muted">Points Expired</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ formatNumber(tbm_points.total_expired) }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <h5 class="mb-2 text-muted">Points Deleted</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ formatNumber(tbm_points.total_deleted_points) }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Takaful Brunei -->

    <div class="row">
      <div class="col-lg-4 col-md-6 col-12">
        <!-- TBA -->
        <!-- <h3 style="color: #78BE20; margin-bottom: 20px;">Takaful Brunei Am (TBA)</h3> -->
        <div class="row">
          <div class="col">
            <div class="card mb-4">
              <div class="card-body">
                <!-- Title -->
                <h3 style="color: #ac8400">Vendor Banner Request</h3>

                <br />

                <!-- Pending -->
                <h5 class="mb-2 text-muted">Pending</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ vendorReq.pendings }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <br />

                <!-- Completed -->
                <h5 class="mb-2 text-muted">Completed</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ vendorReq.completed }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <br />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-12">
        <!-- TBA -->
        <!-- <h3 style="color: #78BE20; margin-bottom: 20px;">Takaful Brunei Am (TBA)</h3> -->
        <div class="row">
          <div class="col">
            <div class="card mb-4">
              <div class="card-body">
                <!-- Title -->
                <h3 style="color: #ac8400">Vendor Product Request</h3>

                <br />

                <!-- Pending -->
                <h5 class="mb-2 text-muted">Pending</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ productReq.pendings }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <br />

                <!-- Completed -->
                <h5 class="mb-2 text-muted">Completed</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ productReq.completed }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <br />

                <!-- Remarks -->
                <h5 class="mb-2 text-muted">Remarks</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ productReq.remarks }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <br />

                <!-- Total -->
                <h5 class="mb-2 text-muted">Total</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ productReq.total }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-12">
        <div class="card mb-4">
          <div class="card-body">
            <!-- Title -->
            <h3 style="color: #ac8400">Survey</h3>

            <br />

            <div class="row">
              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Active</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ survey.active }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Inactive</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ survey.inactive }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <!-- Total -->
                <h5 class="mb-2 text-muted">Total</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ survey.total }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card mb-4">
          <div class="card-body">
            <!-- Title -->
            <h3 style="color: #ac8400">Charity</h3>

            <br />

            <div class="row">
              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Active</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ charity.active }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Inactive</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #000">
                  {{ charity.inactive }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar"
                    style="width: 100%; color: #ac8400"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "dashboard-marketing",

  components: {},

  data() {
    return {
      regVendor: {
        active: 0,
        inactive: 0,
      },

      vendorReq: {
        pendings: 0,
        completed: 0,
        total: 0,
      },

      productReq: {
        pendings: 0,
        completed: 0,
        remarks: 0,
        total: 0,
      },

      survey: {
        active: 0,
        inactive: 0,
        total: 0,
      },

      charity: {
        active: 0,
        inactive: 0,
        total: 0,
      },

      redeem: {
        vendors: 0,
        charity: 0,
      },

      tbm_points: {
        total_earned: 0,
        total_expired: 0,
        total_deleted_points: 0,
      },
    };
  },

  methods: {
    loadData() {
      this.loadVendors();
      this.redeemCharity();
      this.loadCounts();
      this.getAllPoints();
    },
    async loadVendors() {
      if (!this.checkToken()) {
        return;
      }

      try {
        let result = await axios.get(axios.lpsURL + "/vendor", {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
        });
        // this.regVendor = result.data.vendor;
        for (let i = 0; i < result.data.vendor.length; i++) {
          if (result.data.vendor[i].active_banner_link == null) {
            this.regVendor.inactive = this.regVendor.inactive + 1;
          } else {
            this.regVendor.active = this.regVendor.active + 1;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async redeemCharity() {
      if (!this.checkToken()) {
        return;
      }

      try {
        let result = await axios.get(
          axios.lpsURL + "/point/redeem/all?type=2",
          {
            headers: {
              Authorization: "Bearer " + this.checkToken(),
            },
          }
        );
        this.redeem.charity = result.data.total_points_redeemed;
      } catch (error) {
        console.log(error);
      }
    },

    async loadCounts() {
      if (!this.checkToken()) {
        return;
      }

      try {
        let result = await axios.get(
          axios.lpsURL + "/vendor_product/getCounts",
          {
            headers: {
              Authorization: "Bearer " + this.checkToken(),
            },
          }
        );
        this.vendorReq = result.data.vendors;
        this.productReq = result.data.products;
        this.survey = result.data.survey;
        this.charity = result.data.charity;
      } catch (error) {
        console.log(error);
      }
    },

    checkToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        return false;
      }
      token = JSON.parse(token);
      token = token.access_token;
      return token;
    },

    async getAllPoints() {
      if (!this.checkToken()) {
        return;
      }

      try {
        let result = await axios.get(axios.lpsURL + "/point/all", {
          headers: {
            Authorization: "Bearer " + this.checkToken(),
          },
        });
        this.tbm_points.total_earned = result.data.total_points_earned;
        this.tbm_points.total_expired = result.data.expired_points;
        this.redeem.vendors = result.data.total_redeemed_points;
        this.tbm_points.total_deleted_points = result.data.total_deleted_points;
      } catch (error) {
        console.log(error);
      }
    },

    formatNumber(_number) {
      return parseFloat(_number).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
  },

  created() {
    this.loadData();
  },
};
</script>
